module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d8e7411"
    }
  }, [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4#sam_1",
      "id": "sam_33"
    }
  }, [_vm._v("1997")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter5#vas_1",
      "id": "vas_33"
    }
  }, [_vm._v("2014")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter6#One_1",
      "id": "One_33"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter7#Two_1",
      "id": "Two_33"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter8#Three_1",
      "id": "Three_33"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter9#Four_1",
      "id": "Four_33"
    }
  }, [_vm._v("Four")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#Five_1",
      "id": "Five_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#Six_1",
      "id": "Six_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#Seven_1",
      "id": "Seven_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#Eight_1",
      "id": "Eight_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#Nine_1",
      "id": "Nine_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#Ten_1",
      "id": "Ten_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#Eleven_1",
      "id": "Eleven_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#Twelve_1",
      "id": "Twelve_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#Thirteen_1",
      "id": "Thirteen_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#Fourteen_1",
      "id": "Fourteen_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#Fifteen_1",
      "id": "Fifteen_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#Sixteen_1",
      "id": "Sixteen_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#Seventeen_1",
      "id": "Seventeen_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#Eighteen_1",
      "id": "Eighteen_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#Nineteen_1",
      "id": "Nineteen_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#Twenty_1",
      "id": "Twenty_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#Twenty-One_1",
      "id": "Twenty-One_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#Twenty-Two_1",
      "id": "Twenty-Two_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#Twenty-Three_1",
      "id": "Twenty-Three_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#Twenty-Four_1",
      "id": "Twenty-Four_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#Twenty-Five_1",
      "id": "Twenty-Five_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#Twenty-Six_1",
      "id": "Twenty-Six_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#Twenty-Seven_1",
      "id": "Twenty-Seven_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#Twenty-Eight_1",
      "id": "Twenty-Eight_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#Twenty-Nine_1",
      "id": "Twenty-Nine_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#Thirty_1",
      "id": "Thirty_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#Thirty-One_1",
      "id": "Thirty-One_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#Thirty-Two_1",
      "id": "Thirty-Two_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#Thirty-Three_1",
      "id": "Thirty-Three_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#Thirty-Four_1",
      "id": "Thirty-Four_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#Thirty-Five_1",
      "id": "Thirty-Five_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#Thirty-Six_1",
      "id": "Thirty-Six_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42#RE_1",
      "id": "RE_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Group Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#Ab_1",
      "id": "Ab_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44#An_1",
      "id": "An_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Excerpt from Stranger Things")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45#Ano_1",
      "id": "Ano_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21784071","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 75
// module chunks = 0